<script>
  import { useForm } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FormLayout from '../../components/form_layout.svelte'
  import FormSection from '../../components/form_section.svelte'
  import FilterTabs from '../../components/filter_tabs.svelte'
  import TextField from '../../components/form/text_field.svelte'
  import CheckboxField from '../../components/form/checkbox_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'
  import { Button } from '../../components/ui'
  import SocialTab from './social/social_tab.svelte'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  // The server resolves the tab (a ?tab= the admin can't open falls back to the one they
  // can) and sends both tabs with the locked one disabled.
  let { user_id, user = {}, back_url: backUrl = '/users', can_manage_users = false, can_manage_social = false, social = null, tabs = [], active_tab: currentTab = 'account' } = $props()

  // Validation is the server's: each change is checked live by a Precognition request to
  // the real update action, and again on Save.
  const form = useForm({
    user: {
      name: user.name || '',
      email: user.email || '',
      phone: user.phone || '',
      referral_code: user.referral_code || '',
      referral_program: user.referral_program || false,
      influencer_program: user.influencer_program || false,
      quest_curator: user.quest_curator || false
    },
    return_to: backUrl
  }).withPrecognition('patch', `/users/${user_id}`)
  liveValidate(form, 'user')

  const submit = (event) => {
    event.preventDefault()
    $form.patch(`/users/${user_id}`)
  }
</script>

<Layout>
  <PageHeader title={user.name ? `Edit User — ${user.name}` : 'Edit User'} subtitle="Account details and social moderation" />

  {#if tabs.length > 1}
    <div class="mb-6">
      <FilterTabs {tabs} active={currentTab} param="tab" />
    </div>
  {/if}

  {#if currentTab === 'account' && can_manage_users}
    <FormLayout onsubmit={submit}>
      <FormSection title="Account">
        <TextField bind:value={$form.user.email} label="Email" name="email" error={$form.errors['user.email']} />
        <TextField bind:value={$form.user.name} label="Full Name" name="name" error={$form.errors['user.name']} />
        <TextField bind:value={$form.user.phone} label="Phone Number" name="phone" error={$form.errors['user.phone']} />
        <TextField bind:value={$form.user.referral_code} label="Referral Code" name="referral_code" error={$form.errors['user.referral_code']} />
        <CheckboxField bind:checked={$form.user.referral_program} label="Referral Program" name="referral_program" />
        <CheckboxField bind:checked={$form.user.influencer_program} label="Influencer Program" name="influencer_program" />
        <CheckboxField bind:checked={$form.user.quest_curator} label="Quest Curator" name="quest_curator" />
      </FormSection>

      {#snippet footer()}
        <Button href={backUrl} variant="ghost" size="sm">Cancel</Button>
        <SubmitButton processing={$form.processing} label="Save" full={false} />
      {/snippet}
    </FormLayout>
  {/if}

  {#if currentTab === 'social' && can_manage_social}
    <SocialTab {social} />
  {/if}
</Layout>
